export const ItemPreviewI18nKeys = [
  _TL_('Up to {{monetaryDiscount}} off'),
  _TL_('{{monetaryDiscount}} off'),
  _TL_('Up to {{percentDiscount}} off'),
  _TL_('{{percentDiscount}} off'),
  _TL_('On orders over {{amount}}'),
  _TL_('Code {{promotionCode}}'),
  _TL_('Valid {{startDate}} - {{endDate}}'),
  _TL_('Valid {{date}}'),
  _TL_('Starts {{startDate}}'),
  _TL_('Ends {{endDate}}'),
].reduce((m, e) => { m[e] = e; return m; }, {}); // eslint-disable-line no-param-reassign
